<!-- unity-viewer.component.html -->

<h1>Measure</h1>
<iframe class="h-full w-full" [src]="unityViewerUrl" allowfullscreen></iframe>
